import {
  isAutomatedCatalog,
  isBoxCatalog,
  isCatalogDraft,
  isMasterCatalog,
  STATUS,
} from '../../../utils/catalog/catalog';
import { selectCatalog, selectCatalogs } from '../../slices/catalog';
import { createShallowEqualResultSelector } from '../utils';

export const selectDraftProductsCatalog = createShallowEqualResultSelector(
  selectCatalogs,
  (catalogs) => catalogs.find((catalog) => isMasterCatalog(catalog, STATUS.DRAFT)),
);

export const selectIsCatalogDraft = createShallowEqualResultSelector(
  selectCatalog,
  (catalog) => isCatalogDraft(catalog),
);

export const selectIsCatalogBox = createShallowEqualResultSelector(
  selectCatalog,
  (catalog) => isBoxCatalog(catalog),
);

export const selectIsCatalogAutomated = createShallowEqualResultSelector(
  selectCatalog,
  (catalog) => isAutomatedCatalog(catalog),
);
